export default __webpack_public_path__ + "static/media/bg_queroumagenciaslide-familia.88d048c9.png";